module.exports = __webpack_public_path__ + "img/logo-icon.d0d8a158.png";